import axiosClient from "config/axios";
/***
 * Dataservices to show the result laboratories with the get method
 */

export const getLabsResult = async (data) => {
  let result = {};
  await axiosClient
    .get("/laboratories/studies/", data)
    .then((response) => {
      result = {
        error: false,
        result: response.data,
      };
    })
    .catch((error) => {
      result = {
        error: true,
        message: "auth__server_error",
      };
    });
  return result;
};
